/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_IntroInputs */

const en_to_csv_intro = /** @type {(inputs: To_Csv_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flatten an array of objects into a spreadsheet table. Keys become the header row, records become rows, and values that would break the format are quoted for you.`)
};

const ko_to_csv_intro = /** @type {(inputs: To_Csv_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`객체 배열을 스프레드시트 표로 펼칩니다. 키는 헤더 행이 되고 레코드는 행이 되며, 형식을 깨뜨릴 값은 알아서 인용됩니다.`)
};

const ja_to_csv_intro = /** @type {(inputs: To_Csv_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オブジェクトの配列を表計算の表に展開します。キーがヘッダ行になり、レコードが行になり、形式を壊しうる値は自動で引用されます。`)
};

/**
* | output |
* | --- |
* | "Flatten an array of objects into a spreadsheet table. Keys become the header row, records become rows, and values that would break the format are quoted for ..." |
*
* @param {To_Csv_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_intro = /** @type {((inputs?: To_Csv_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_intro(inputs)
	if (locale === "ko") return ko_to_csv_intro(inputs)
	return ja_to_csv_intro(inputs)
});